<script setup lang="ts">
defineProps<{
  to: string
  label: string
}>()

const { styles } = useVariants('languageButton')
</script>

<template>
  <NuxtLink :to="to" :class="styles.base()">
    {{ label }}
  </NuxtLink>
</template>
